import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import UIButton from 'UIComponents/button/UIButton';
import { USER_TEAMS_HREF } from 'ui-forms-components/constants/EmailNotification';
import { BY_DATE } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ByDate = () => /*#__PURE__*/_jsx(FormattedDateTime, {
  value: BY_DATE,
  format: "MMMM Do"
});
const DownloadButton = ({
  handleDownload
}) => /*#__PURE__*/_jsx(UIButton, {
  use: "tertiary",
  size: "sm",
  onClick: handleDownload,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "notificationRecipientsSelect.banner.downloadButton"
  })
});
const NotificationRecipientBannerBody = ({
  handleDownload
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "notificationRecipientsSelect.banner.description_jsx",
      elements: {
        ByDate,
        UILink,
        Br: () => /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx("br", {})
        })
      },
      options: {
        href: USER_TEAMS_HREF
      }
    })
  }), /*#__PURE__*/_jsx(DownloadButton, {
    handleDownload: handleDownload
  })]
});
const NotificationRecipientBanner = ({
  onClose,
  handleDownload
}) => /*#__PURE__*/_jsx(UIAlert, {
  type: "info",
  "data-test-id": "notification-recipient-banner",
  className: "m-bottom-6",
  closeable: true,
  onClose: onClose,
  titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      ByDate
    },
    message: "notificationRecipientsSelect.banner.header_jsx"
  }),
  children: /*#__PURE__*/_jsx(NotificationRecipientBannerBody, {
    handleDownload: handleDownload
  })
});
export default NotificationRecipientBanner;